interface ZakekeMessageCommon {
    readonly zakekeMessageType: number | string;
}

interface ZakekeMessageCustomizerAddToCart extends ZakekeMessageCommon {
    readonly zakekeMessageType: 0;
    readonly designId: string;
}

interface ZakekeMessageComposerAddToCart {
    readonly zakekeMessageType: 'AddToCart';
    readonly message: {
        readonly composition: string;
        readonly preview?: string;
        readonly quantity?: number;
    };
}

interface ZakekeMessageDesignChange extends ZakekeMessageCommon {
    readonly zakekeMessageType: 1;
}

export type ZakekeMessage = ZakekeMessageCommon | ZakekeMessageCustomizerAddToCart | ZakekeMessageComposerAddToCart | ZakekeMessageDesignChange;

export const isCustomizerAddToCartMessage = (message: any): message is ZakekeMessageCustomizerAddToCart => message?.zakekeMessageType === 0;

export const isComposerAddToCartMessage = (message: any): message is ZakekeMessageComposerAddToCart =>
    message?.zakekeMessageType === 'AddToCart' && !!message?.message?.composition;

/** @deprecated Use isCustomizerAddToCartMessage instead */
export const isAddToCartMessage = isCustomizerAddToCartMessage;

export const isDesignChangeMessage = (message: ZakekeMessage): message is ZakekeMessageDesignChange => message.zakekeMessageType === 1;
